import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">🚲</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">404</h1>
        <p className="text-gray-500 mb-8">Страница не найдена</p>
        <button
          onClick={() => navigate(user ? (user.role === 'owner' ? '/owner' : '/manager') : '/login')}
          className="bg-brand-600 text-white px-6 py-3 rounded-xl font-medium"
        >
          На главную
        </button>
      </div>
    </div>
  )
}
